module.exports = __webpack_public_path__ + "img/video-photo.622bbd00.jpg";